
// NOTE: Local copy of React Progress Bar component to customize based on FN requirement
// Ref: https://github.com/iqnivek/react-circular-progressbar/blob/master/src/index.jsx
import React, {Component} from 'react';

const MIN_PERCENTAGE = 0;
const MAX_PERCENTAGE = 100;
const MAX_X = 100;
const MAX_Y = 100;
const FULL_RADIUS = 50;
const CENTER_X = 50;
const CENTER_Y = 50;

class CircularProgressbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startColor: '#ADFF2F',
      endColor: '#008740',
      rotation: '90',
      idCSS: 'idCSS'
    };
  }

  getBackgroundPadding() {
    if (this.props.background) {
      // default padding to be the same as strokeWidth
      // compare to null because 0 is falsy
      if (this.props.backgroundPadding == null) {
        return this.props.strokeWidth;
      }
      return this.props.backgroundPadding;
    }
    // don't add padding if not displaying background
    return 0;
  }

  getPathDescription() {
    const radius = this.getPathRadius();
    const rotation = this.props.counterClockwise ? 1 : 0;

    // Move to center of canvas
    // Relative move to top canvas
    // Relative arc to bottom of canvas
    // Relative arc to top of canvas
    return `
      M ${CENTER_X},${CENTER_Y}
      m 0,-${radius}
      a ${radius},${radius} ${rotation} 1 1 0,${2 * radius}
      a ${radius},${radius} ${rotation} 1 1 0,-${2 * radius}
    `;
  }

  getPathStyles() {
    const diameter = Math.PI * 2 * this.getPathRadius();
    const truncatedPercentage = Math.min(Math.max(this.props.percentage, MIN_PERCENTAGE), MAX_PERCENTAGE);
    const dashoffset = ((100 - truncatedPercentage) / 100) * diameter;

    return {
      strokeDasharray: `${diameter}px ${diameter}px`,
      strokeDashoffset: `${this.props.counterClockwise ? -dashoffset : dashoffset}px`,
    };
  }

  getPathRadius() {
    // the radius of the path is defined to be in the middle, so in order for the path to
    // fit perfectly inside the 100x100 viewBox, need to subtract half the strokeWidth
    return FULL_RADIUS - (this.props.strokeWidth / 2);
  }

  render() {
    const {className, classes, styles, strokeWidth, text} = this.props;
    const pathDescription = this.getPathDescription();
    let { startColor, endColor, idCSS, rotation } = this.state; 
    let gradientTransform = `rotate(${rotation})`;

    return (
      <svg
        className={`${classes.root} ${className}`}
        style={styles.root}
        viewBox={`0 0 ${MAX_X} ${MAX_Y}`}
        title="progressBar"
      >
        {
            this.props.background ? (
            <circle
                className={classes.background}
                style={styles.background}
                cx={CENTER_X}
                cy={CENTER_Y}
                r={FULL_RADIUS}
            />
            ) : null
        }

        <path
          className={classes.trail}
          style={styles.trail}
          d={pathDescription}
          strokeWidth={strokeWidth}
          fillOpacity={0}
        />

        <path
          className={classes.path}
          d={pathDescription}
          strokeWidth={strokeWidth}
          fillOpacity={0}
          style={Object.assign({}, styles.path, this.getPathStyles())}
        />

        {
          text ? (
            <text
              className={classes.text}
              style={styles.text}
              x={CENTER_X}
              y={CENTER_Y}
            >
              {text}
            </text>
          ) : null
        }
        <defs>
            <linearGradient id={idCSS} gradientTransform={gradientTransform}>
                <stop offset="0%" stopColor={startColor} />
                <stop offset="100%" stopColor={endColor} />
            </linearGradient>
        </defs>
      </svg>
    );
  }
}

// CircularProgressbar.propTypes = {
//   percentage: PropTypes.number.isRequired,
//   className: PropTypes.string,
//   text: PropTypes.string,
//   classes: PropTypes.objectOf(PropTypes.string),
//   styles: PropTypes.objectOf(PropTypes.object),
//   strokeWidth: PropTypes.number,
//   background: PropTypes.bool,
//   backgroundPadding: PropTypes.number,
//   initialAnimation: PropTypes.bool,
//   counterClockwise: PropTypes.bool,
// };

CircularProgressbar.defaultProps = {
  strokeWidth: 8,
  className: '',
  text: null,
  classes: {
    root: 'CircularProgressbar',
    trail: 'CircularProgressbar-trail',
    path: 'CircularProgressbar-path',
    text: 'CircularProgressbar-text',
    background: 'CircularProgressbar-background',
  },
  styles: {
    root: {},
    trail: {},
    path: {},
    text: {},
    background: {},
  },
  background: false,
  counterClockwise: false,
};

export default CircularProgressbar;


// WEBPACK FOOTER //
// ./src/manageMyAccount/CircularProgressbar.js